import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateTagMutation } from "../graphql/mutations";
import type {
  CreateTagMutationType,
  CreateTagMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateTagMutation = (
  options?: MutationHookOptions<
    CreateTagMutationType,
    CreateTagMutationVariablesType
  >
) => {
  return useMutation<CreateTagMutationType, CreateTagMutationVariablesType>(
    CreateTagMutation,
    options
  );
};
